import { MercureClient } from './application/MercureClient';
import type { MercureClientConfig } from './application/MercureClient';
import { ConnectionManager, SafeUpdateValidator } from '~/composables/mercure/infrastructure';
import { SubscriptionManager } from '~/composables/mercure/application';

export * from './core';
export * from './application';
export * from './infrastructure';
export * from './shared';

export function createMercureClient (config: MercureClientConfig): MercureClient {
  const connectionManager: ConnectionManager = new ConnectionManager();
  const subscriptionManager: SubscriptionManager = new SubscriptionManager();
  const updateValidator: SafeUpdateValidator = new SafeUpdateValidator();

  return new MercureClient(config, connectionManager, subscriptionManager, updateValidator);
}
